module.exports = __webpack_public_path__ + "static/Lamentum0-21689f42d2cf9a805b4e3d4ca4c3d81a.png";